export const parseScoreToString = value => {
  if (value < 0.5) return 'Very low';
  if (value <= 0.8) return 'Low';
  if (value <= 1.2) return 'Medium';
  if (value <= 3) return 'High';
  return 'Very high';
};
